export const LOGOUT_TOKEN = 'LOGOUT_TOKEN'
export const LOGOUT_RESPONSE = 'LOGOUT_RESPONSE'
export const LOGOUT_FAILED = 'LOGOUT_FAILED'